module.exports = __webpack_public_path__ + "static/media/youtube.862ac99b.png";